export default __webpack_public_path__ + "static/media/3B069A_1_0.de4896a8.woff2";